import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=119c1939&scoped=true&"
import script from "./Modal.vue?vue&type=script&lang=tsx&"
export * from "./Modal.vue?vue&type=script&lang=tsx&"
import style0 from "./Modal.vue?vue&type=style&index=0&id=119c1939&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119c1939",
  null
  
)

export default component.exports